<template>
    <div class="content-item">
        <img :src="src" alt="">
        <div class="content-item-detail">
            <h3>{{item.title}}</h3>
            <p>{{item.desc}}</p>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        item: {
            required: true,
            type: Object
        }
    },
    computed: {
        src() {
            return this.item.img
        }
    }
}
</script>
<style>
.content-item{
    flex: 1;
    display: flex;
    height: 280px;
}
.content-item:hover{
    box-shadow: 0 0 15px 0 rgba(0,0,0,0.10); 
    border-radius: 4px;
    background-color: #fff;
    color: #303133;
    transition: .3s;
}
.content-item img{
    /* width: 56px; */
    height: 56px;
    margin: 40px 22px;
}
.content-item-detail{
    margin-top: 20px;
    padding-right: 30px;
    text-align: left;
}
.content-item-detail h3{
    padding: 20px 0;
    font-family: PingFangSC-Regular;
    font-size: 22px;
    font-weight: normal;
    color: #000000;
}
.content-item-detail p{
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #666666;
    letter-spacing: 0;
    line-height: 22px;
}
</style>